import React from 'react'
import styles from 'styles/layout/AboutUsHeaderSection.module.sass'
import HeaderNavigation from '../header/HeaderNavigation';
import SectionHeader from 'components/common/SectionHeader';
import ExperienceMetricsCard from 'components/cards/ExperienceMetricsCard';

/**
 * AboutUsHeaderSection component renders the header section for the "About Us" page.
 * 
 * This section includes:
 * - A navigation header with a dark theme.
 * - A title and subtitle describing the mission and vision of the platform.
 * - A hero description highlighting the core focus of the organization.
 * - An experience metrics card showcasing key achievements and focus areas.
 * - A mission and vision statement emphasizing the importance of data analytics for African markets.
 * 
 * @component
 * 
 * @example
 * // Example usage of the AboutUsHeaderSection component
 * import AboutUsHeaderSection from 'components/layout/AboutUsHeaderSection';
 * 
 * const App: React.FC = () => (
 *   <AboutUsHeaderSection />
 * );
 * 
 * export default App;
 */
const AboutUsHeaderSection: React.FC = () => {
    return (
        <section className={styles['header-section']}>
            <div className={styles['main-wrapper']}>
                <HeaderNavigation theme='dark' />
                <div className={styles['background-container']}>
                    <SectionHeader
                        title='WHO WE ARE'
                        subtitle='The go-to hub for everything data on Africa.' 
                    />
                    <p className={styles['hero-description']}>Whether you&apos;re in search of a ready-to-purchase report or are looking to leverage our AI analyst - ZeroneBot - to create your own from scratch, we have an extensive collection of consumer/market analytics and databases across 3 focus industries: agriculture &amp; agribusiness, retail &amp; consumer goods, and tourism &amp; hospitality. We house several millions of datapoints on Ghana, Nigeria, Kenya and South Africa. We are your trusted partner in delivering advanced analytics and intelligent solutions across Africa.</p>
                    <ExperienceMetricsCard />
                    <p className={styles['mission-vision']}>
                    <span className={styles['highlight']}>Empowering decisions with data and analytics.</span> We see a future where consumer, market and industry analytics on Africa are generally available and readily accessible. We&apos;re building the continent&apos;s most comprehensive and robust datahub; leveraging the world&apos;s latest artificial intelligence technologies to generate real-time insights. With our solution, the world will have access to an extensive supply of culturally relevant African data needed for making simple everyday choices and complex business decisions.
                    </p>
                </div>
            </div>
        </section>
    )
}

export default AboutUsHeaderSection;